module.exports = __webpack_public_path__ + "media/splash/launch-1125x2436-5bf3b344.png";